import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { UsersIdFailure, UsersIdRequest, UsersIdReset, UsersIdSuccess } from './actions';
import { UserIdentification } from '@models/swagger';

export const featureKey = 'usersId';

export interface State {
  data: UserIdentification | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(UsersIdFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(UsersIdRequest, state => ({ ...state, error: null, loading: true })),
    on(UsersIdSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(UsersIdReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
